export default __webpack_public_path__ + "static/media/ic_date_range_24px.e3e02834.svg";